import { OverviewContentQueryResult } from '@/components/organisms/overviewBlock/overviewBlock'
import { create } from 'zustand'

type State = { result?: OverviewContentQueryResult }

export type SelectedFilters = { [key: string]: Array<string> }

type Action = {
  updateOverviewResults: (result?: OverviewContentQueryResult) => void
}

export const useOverviewResultsStore = create<State & Action>((set) => ({
  result: undefined,
  updateOverviewResults: (result) => set(() => ({ result: result })),
}))
